// frontend/admin-portal/src/components/products/ProductPriceCard.jsx
import React from "react";
import { Card, Title, MarginBadge } from "@fiberhome/shared-ui";
import { useSettings } from "../../contexts/SettingsContext";
import {
  computeProfit,
  formatMoney,
  computeMargin,
} from "@fiberhome/shared-ui";

export default function ProductPriceCard({ product }) {
  const { get } = useSettings();
  const symbol = get("finance.currencySymbol", "IQD");

  const price = Number(product?.price) || 0;
  const totalCost = Number(product?.totalCost) || 0;
  const factoryCost = Number(product?.costPrice) || 0;
  const landedCost = totalCost || factoryCost;

  const profit = computeProfit(price, landedCost);
  const margin = computeMargin(price, landedCost);

  return (
    <Card title="Pricing">
      <div className="fh-price-row">
        <span className="text-muted">Selling Price</span>
        <Title level={3} className="mb-0">
          {formatMoney(price, { symbol })}
        </Title>
      </div>

      <div className="fh-kv__row mt-3">
        <span className="text-muted">Factory cost (FOB)</span>
        <span>{formatMoney(factoryCost, { symbol })}</span>
      </div>

      <div className="fh-kv__row">
        <span className="text-muted">Total cost (landed)</span>
        <span style={{ fontWeight: 600 }}>
          {formatMoney(landedCost, { symbol })}
        </span>
      </div>

      <div className="fh-price-row mt-2">
        <span className="text-muted">Profit per unit</span>
        <span
          style={{
            fontWeight: 600,
            color: profit >= 0 ? "var(--fh-success)" : "var(--fh-danger)",
          }}
        >
          {formatMoney(profit, { symbol })}
        </span>
      </div>

      <div className="fh-price-row mt-2">
        <span className="text-muted">Margin</span>
        <MarginBadge value={margin} />
      </div>
    </Card>
  );
}
